<template>
    <div class="app-container">
        <!-- 查询条件 -->
        <div class="search-div common-section-bg">
            <div class="shaixuan-item">
                <el-select
                    v-model="queryParam.commId"
                    clearable
                    filterable
                    placeholder="请选择小区"
                >
                    <el-option
                        v-for="item in optionList"
                        :key="item.commId"
                        :label="item.commName"
                        :value="item.commId"
                    />
                </el-select>
            </div>
            <div class="shaixuan-item">
                <el-input
                    v-model="queryParam.name"
                    size="mini"
                    clearable
                    placeholder="车牌号"
                />
            </div>
            <div class="shaixuan-item">
                <el-input
                    v-model="queryParam.ownerName"
                    size="mini"
                    clearable
                    placeholder="业主姓名"
                />
            </div>
            <div class="shaixuan-item">
                <el-input
                    v-model="queryParam.ownerPhone"
                    size="mini"
                    clearable
                    placeholder="业主电话"
                />
            </div>
            <div class="shaixuan-item">
                <el-date-picker
                    v-model="queryParam.appointmentRange"
                    type="daterange"
                    clearable
                    unlink-panels
                    value-format="yyyy-MM-dd"
                    start-placeholder="预约开始日期"
                    end-placeholder="预约结束日期"
                    range-separator="至"
                />
            </div>
            <div class="shaixuan-item">
                <el-date-picker
                    v-model="queryParam.quTimeRange"
                    type="datetimerange"
                    clearable
                    unlink-panels
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="取车开始时间"
                    end-placeholder="取车结束时间"
                    range-separator="至"
                />
            </div>
            <div class="shaixuan-item">
                <el-date-picker
                    v-model="queryParam.huanTimeRange"
                    type="datetimerange"
                    clearable
                    unlink-panels
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="还车开始时间"
                    end-placeholder="还车结束时间"
                    range-separator="至"
                />
            </div>

            <div class="shaixuan-item">
                <el-select
                    v-model="queryParam.liucheng_status"
                    clearable
                    placeholder="当前状态"
                >
                    <el-option label="已取消" :value="-1" />
                    <el-option label="待取车" :value="1" />
                    <el-option label="待还车" :value="2" />
                    <el-option label="待退押金" :value="3" />
                    <el-option label="已完成" :value="4" />
                </el-select>
            </div>
            <div class="shaixuan-item">
                <el-button
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    @click="searchClick()"
                    icon="el-icon-search"
                >
                    查询
                </el-button>
                <el-button
                    @click="resetSearch()"
                    icon="el-icon-refresh"
                >
                    重置
                </el-button>
                <el-button
                    @click="clickXianxiaZuche"
                    type="primary"
                    style="background: #1890ff; border-color: #1890ff"
                    icon="el-icon-plus"
                >
                    线下租车
                </el-button>
            </div>
        </div>
        <!-- 列表展示 -->
        <!--order_sn订单号，commId小区ID关联小区显示小区名称，resourceId住房ID关联住房显示资源名称，name姓名wxUser的name,phone联系方式wxuser的phone,appointment_date预约日期，appointment_days预约天数
        qu_time取车时间，huan_time还车时间,yajin押金,koukuan_yajin应扣押金，tui_yajin已退还押金-->
        <div class="common-section-bg common-section-body">
            <el-table
                v-loading="listLoading"
                :data="tableData"
                size="mini"
                style="width: 100%; min-height: 300px"
                stripe
            >
                <el-table-column prop="id" label="ID" width="80" align="center" />
                <el-table-column label="订单号" width="180" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getOrderSn(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="小区" width="140" align="center">
                    <template slot-scope="scope">
                        {{ getCommunityName(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="资源名称" width="150" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getResourceName(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="车牌号" width="150" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getPlateNo(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="姓名" width="120" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getUserName(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="联系方式" width="120" align="center">
                    <template slot-scope="scope">
                        {{ getPhone(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="当前状态" width="100" align="center">
                    <template slot-scope="scope">
                        <span>{{ getStatusText(getLiuchengStatus(scope.row)) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="预约日期" width="150" align="center">
                    <template slot-scope="scope">
                        {{ getAppointmentDate(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="预约天数" width="100" align="center">
                    <template slot-scope="scope">
                        {{ getAppointmentDays(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="取车时间" width="160" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getQuTime(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="还车时间" width="160" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getHuanTime(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="退押金时间" width="180" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getTuiYajinDate(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="押金" width="100" align="center">
                    <template slot-scope="scope">
                        {{ formatCurrencyDisplay(getYajin(scope.row)) }}
                    </template>
                </el-table-column>
                <el-table-column label="下单时间" width="180" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ getCreateTime(scope.row) }}
                    </template>
                </el-table-column>

                <el-table-column fixed="right" align="center" label="操作" minWidth="430">
                    <template slot-scope="scope">
                        <div class="btns-wrap">
                            <el-button
                                type="info"
                                size="mini"
                                @click="openDetailDrawer(scope.row)"
                                icon="el-icon-document"
                            >
                                预约详情
                            </el-button>
                            <!--如果scope.row.qu_time ==null 则显示取车按钮，如果不为null则显示已取车-->
                            <el-button
                                :type="scope.row.qu_time ? 'success' : 'primary'"
                                :plain="!!scope.row.qu_time"
                                size="mini"
                                @click="quche(scope.row)"
                                icon="el-icon-check"
                            >
                                {{ scope.row.qu_time ? '已取车' : '取车' }}
                            </el-button>
                            <!--如果scope.row.huan_time ==null 则显示还车按钮，如果不为null则显示已还车-->
                            <el-button
                                :type="scope.row.huan_time ? 'info' : 'warning'"
                                :plain="!!scope.row.huan_time"
                                size="mini"
                                @click="huanche(scope.row)"
                                icon="el-icon-back"
                            >
                                {{ scope.row.huan_time ? '已还车' : '还车' }}
                            </el-button>
                            <el-button
                                type="success"
                                size="mini"
                                @click="tuiyajin(scope.row)"
                                icon="el-icon-money"
                            >
                                款项信息
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination
                v-show="total"
                :total="total"
                :page.sync="queryParam.page"
                :limit.sync="queryParam.size"
                @pagination="getList"
            />
        </div>
        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showXianxiaDrawer"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="500px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">线下租车</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeDrawerFun" />
                </div>
            </template>
            <div class="custom-content">
                <div class="add-danwei">
                    <el-form
                        ref="ruleForm"
                        :model="xianxiaData"
                        :rules="xianxiaRules"
                        label-width="100px"
                    >
                        <el-form-item label="小区" prop="commId">
                            <el-select
                                v-model="xianxiaData.commId"
                                clearable
                                filterable
                                placeholder="请选择小区"
                                @change="onCommChange"
                            >
                                <el-option
                                    v-for="item in optionList"
                                    :key="item.commId"
                                    :label="item.commName"
                                    :value="item.commId"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="住房" prop="resourceId">
                            <el-select
                                v-model="xianxiaData.resourceId"
                                clearable
                                filterable
                                placeholder="请选择住房"
                                @change="changeFangwu"
                            >
                                <el-option
                                    v-for="item in fangwuList"
                                    :key="item.resourceId"
                                    :label="item.resourceName"
                                    :value="item.resourceId"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="业主姓名" prop="name">
                            <el-input v-model="xianxiaData.name" placeholder="请输入业主姓名" />
                        </el-form-item>
                        <el-form-item label="业主手机号" prop="phone">
                            <el-input v-model="xianxiaData.phone" placeholder="请输入业主手机号" />
                        </el-form-item>
                        <el-form-item label="预约日期" prop="appointment_date" @change="getCheList(xianxiaData.commId)">
                            <el-date-picker
                                v-model="xianxiaData.appointment_date"
                                type="datetime"
                                placeholder="选择预约日期和时间"
                                format="yyyy-MM-dd HH:mm"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            />
                        </el-form-item>
                        <el-form-item label="预约天数" prop="tianshu">
                            <el-input-number v-model="xianxiaData.appointment_days" :min="1" placeholder="请输入预约天数" />
                        </el-form-item>
                        <el-form-item label="车辆" prop="zuche_che_info_id">
                            <el-select
                                v-model="xianxiaData.zuche_che_info_id"
                                clearable
                                filterable
                                placeholder="请选择车辆"
                            >
                                <el-option
                                    v-for="item in cheList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                />
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="其他手机号" prop="other_phone">
                            <el-input v-model="xianxiaData.other_phone" placeholder="请输入其他手机号" />
                        </el-form-item> -->
                        <el-form-item label="已付押金金额" prop="yajin">
                            <el-input-number v-model="xianxiaData.yajin" :min="0" :precision="2" placeholder="请输入押金金额" />
                        </el-form-item>
                        <el-form-item label="驾驶人身份证正面" prop="idcard_thumb">
                            <image-upload
                                ref="idcardThumbUpload"
                                :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M`"
                                :image-list="idcardThumbDefaultList"
                                :maxNumber="1"
                                @updateImg="onUpdateIdcardThumb"
                            />
                        </el-form-item>
                        <el-form-item label="驾驶人身份证反面" prop="idcard_thumb_fan">
                            <image-upload
                                ref="idcardThumbFanUpload"
                                :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M`"
                                :image-list="idcardThumbFanDefaultList"
                                :maxNumber="1"
                                @updateImg="onUpdateIdcardThumbFan"
                            />
                        </el-form-item>
                        <el-form-item label="驾驶执照正面" prop="jiashizheng">
                            <image-upload
                                ref="jiashizhengUpload"
                                :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M`"
                                :image-list="jiashizhengDefaultList"
                                :maxNumber="1"
                                @updateImg="onUpdateJiashizheng"
                            />
                        </el-form-item>
                        <el-form-item label="协议照片" prop="xieyi_pic">
                            <image-upload
                                ref="xieyiPicUpload"
                                :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M`"
                                :image-list="xieyiPicDefaultList"
                                :maxNumber="1"
                                @updateImg="onUpdateXieyiPic"
                            />
                        </el-form-item>

                        <el-form-item label="备注" prop="beizhu">
                            <el-input v-model="xianxiaData.remark" type="textarea" :rows="3" placeholder="请输入备注" />
                        </el-form-item>
                    </el-form>
                    <div class="fix-fotter">
                        <el-button
                            style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;"
                            size="mini"
                            type="primary"
                            @click="submitXianxiaZuche"
                        >
                            提交
                        </el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
        <!-- 预约详情抽屉 -->
        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showDetailDrawer"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="600px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">预约详情</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeDetailDrawer" />
                </div>
            </template>
            <div class="custom-content">
                <el-form ref="detailEditFormRef" :model="detailEditForm" :rules="detailEditRules" label-width="120px">
                    <el-form-item label="订单ID"><span>{{ detailData.id || '--' }}</span></el-form-item>
                    <el-form-item label="订单号"><span>{{ getOrderSn(detailData) }}</span></el-form-item>
                    <el-form-item label="小区"><span>{{ getCommunityName(detailData) }}</span></el-form-item>
                    <el-form-item label="资源名称"><span>{{ getResourceName(detailData) }}</span></el-form-item>
                    <el-form-item label="车牌号" prop="zuche_che_info_id">
                        <el-select
                            v-if="detailEditMode"
                            v-model="detailEditForm.zuche_che_info_id"
                            clearable
                            filterable
                            placeholder="请选择车辆"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in detailCheList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                        <span v-else>{{ getPlateNo(detailData) }}</span>
                    </el-form-item>
                    <el-form-item label="姓名"><span>{{ getUserName(detailData) }}</span></el-form-item>
                    <el-form-item label="联系方式"><span>{{ getPhone(detailData) }}</span></el-form-item>
                    <!-- <el-form-item label="其他手机号"><span>{{ getOtherPhone(detailData) }}</span></el-form-item> -->
                    <el-form-item label="预约日期" prop="appointment_date">
                        <el-date-picker
                            v-if="detailEditMode"
                            v-model="detailEditForm.appointment_date"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择预约日期"
                            style="width: 100%"
                            @change="onDetailAppointmentDateChange"
                        />
                        <span v-else>{{ getAppointmentDate(detailData) }}</span>
                    </el-form-item>
                    <el-form-item label="预约天数" prop="appointment_days">
                        <el-input-number
                            v-if="detailEditMode"
                            v-model="detailEditForm.appointment_days"
                            :min="1"
                            controls-position="right"
                            style="width: 100%"
                        />
                        <span v-else>{{ getAppointmentDays(detailData) }}</span>
                    </el-form-item>
                    <el-form-item label="取车时间" prop="qutime">
                        <el-date-picker
                            v-if="detailEditMode"
                            v-model="detailEditForm.qutime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="请选择取车时间"
                            style="width: 100%"
                        />
                        <span v-else>{{ getQuTime(detailData) }}</span>
                    </el-form-item>
                    <el-form-item label="还车时间"><span>{{ getHuanTime(detailData) }}</span></el-form-item>
                    <el-form-item label="押金"><span>{{ formatCurrencyDisplay(getYajin(detailData)) }}</span></el-form-item>
                    <el-form-item label="应扣押金"><span>{{ formatCurrencyDisplay(getKoukuanYajin(detailData)) }}</span></el-form-item>
                    <el-form-item label="已退还押金"><span>{{ formatCurrencyDisplay(getTuiYajin(detailData)) }}</span></el-form-item>
                    <el-form-item label="驾驶人身份证正面">
                        <div class="detail-img-wrap">
                            <el-image
                                v-if="getSingleImage(detailData, 'idcard_thumb')"
                                :src="getSingleImage(detailData, 'idcard_thumb')"
                                :preview-src-list="[getSingleImage(detailData, 'idcard_thumb')]"
                                class="detail-img"
                                fit="cover"
                            />
                            <span v-else>--</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="驾驶人身份证反面">
                        <div class="detail-img-wrap">
                            <el-image
                                v-if="getSingleImage(detailData, 'idcard_thumb_fan')"
                                :src="getSingleImage(detailData, 'idcard_thumb_fan')"
                                :preview-src-list="[getSingleImage(detailData, 'idcard_thumb_fan')]"
                                class="detail-img"
                                fit="cover"
                            />
                            <span v-else>--</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="驾驶执照">
                        <div class="detail-img-wrap">
                            <el-image
                                v-if="getSingleImage(detailData, 'jiashizheng')"
                                :src="getSingleImage(detailData, 'jiashizheng')"
                                :preview-src-list="[getSingleImage(detailData, 'jiashizheng')]"
                                class="detail-img"
                                fit="cover"
                            />
                            <span v-else>--</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="协议照片">
                        <div class="detail-img-wrap">
                            <el-image
                                v-if="getSingleImage(detailData, 'sign_xingming')"
                                :src="getSingleImage(detailData, 'sign_xingming')"
                                :preview-src-list="[getSingleImage(detailData, 'sign_xingming')]"
                                class="detail-img"
                                fit="cover"
                            />
                            <span v-else>--</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="当前状态"><span>{{ getStatusText(getLiuchengStatus(detailData)) }}</span></el-form-item>
                    <el-form-item label="下单时间"><span>{{ getCreateTime(detailData) }}</span></el-form-item>
                    <el-form-item label="备注"><span>{{ detailData.remark || '--' }}</span></el-form-item>
                </el-form>
                <div class="detail-actions">
                    <el-button
                        v-if="!detailEditMode"
                        type="primary"
                        :disabled="!canStartDetailEdit"
                        @click="startDetailEdit"
                    >
                        编辑
                    </el-button>
                    <el-button
                        v-if="detailEditMode"
                        @click="cancelDetailEdit"
                    >
                        取消编辑
                    </el-button>
                    <el-button
                        v-if="detailEditMode"
                        type="primary"
                        :loading="detailEditLoading"
                        :disabled="detailEditLoading"
                        @click="submitDetailEdit"
                    >
                        保存
                    </el-button>
                    <el-button
                        v-if="showDetailCancelBtn"
                        type="danger"
                        :loading="detailCancelLoading"
                        :disabled="detailCancelLoading || detailEditMode"
                        @click="cancelDetailOrder"
                    >
                        取消订单
                    </el-button>
                </div>
            </div>
        </el-drawer>
        <quche-info
            :visible.sync="showQucheDrawer"
            :order="currentOrder"
            @success="getList"
            @closed="onQucheDrawerClosed"
        />
        <huanche-info
            :visible.sync="showHuancheDrawer"
            :order="currentOrder"
            @success="getList"
            @closed="onHuancheDrawerClosed"
        />
        <!-- 退押金抽屉 -->
        <el-drawer
            custom-class="custom-drawer"
            :visible.sync="showTuiyajinDrawer"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :show-close="false"
            size="600px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">退押金操作</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeTuiyajinDrawer" />
                </div>
            </template>
            <div class="custom-content" style="padding: 30px;">
                <div class="tuiyajin-panels">
                    <div class="tuiyajin-card">
                        <div class="tuiyajin-card-title">支付信息</div>
                        <div class="tuiyajin-grid">
                            <div class="tuiyajin-item">
                                <div class="label">已交押金</div>
                                <div class="value">{{ formatCurrencyDisplay(tuiyajinData.pay_price) }}</div>
                            </div>
                            <div class="tuiyajin-item">
                                <div class="label">支付类型</div>
                                <div class="value">{{ getPayTypeText(tuiyajinData.pay_type) }}</div>
                            </div>
                            <div class="tuiyajin-item">
                                <div class="label">支付使用积分数</div>
                                <div class="value">{{ tuiyajinData.score }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="tuiyajin-card">
                        <div class="tuiyajin-card-title">租车信息</div>
                        <div class="tuiyajin-grid">
                            <div class="tuiyajin-item">
                                <div class="label">预约时长</div>
                                <div class="value">{{ tuiyajinData.appointment_days }} 天</div>
                            </div>
                            <div class="tuiyajin-item">
                                <div class="label">实际使用天数</div>
                                <div class="value">{{ tuiyajinData.use_days }} 天</div>
                            </div>
                            <div class="tuiyajin-item">
                                <div class="label">免费使用时长</div>
                                <div class="value">{{ tuiyajinData.free_days }} 天</div>
                            </div>
                            <div class="tuiyajin-item">
                                <div class="label">超免天数</div>
                                <div class="value">{{ tuiyajinData.over_free_days }} 天</div>
                            </div>
                        </div>
                    </div>

                    <div class="tuiyajin-card">
                        <div class="tuiyajin-card-title">还车扣费信息</div>
                        <div class="tuiyajin-grid">
                            <div class="tuiyajin-item">
                                <div class="label">超免日扣费</div>
                                <div class="value">{{ formatCurrencyDisplay(tuiyajinData.overdue_day_fee*tuiyajinData.over_free_days) }}</div>
                            </div>
                            <div class="tuiyajin-item">
                                <div class="label">违章金额</div>
                                <div class="value">{{ formatCurrencyDisplay(tuiyajinData.weizhang_jine) }}</div>
                            </div>
                            <div class="tuiyajin-item highlight">
                                <div class="label">还车总扣除</div>
                                <div class="value">{{ formatCurrencyDisplay(tuiyajinData.huan_kouchu_jine) }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="tuiyajin-card">
                        <div class="tuiyajin-card-title">退押金信息</div>
                        <div class="tuiyajin-grid">
                            <div class="tuiyajin-item highlight">
                                <div class="label">{{ tuiyajinAmountLabel }}</div>
                                <div class="value">{{ formatCurrencyDisplay(tuiyajinAmountDisplay) }}</div>
                            </div>
                            <div class="tuiyajin-item highlight">
                                <div class="label">实退押金</div>
                                <div class="value">{{ formatCurrencyDisplay(tuiyajinData.tui_yajin) }}</div>
                            </div>
                             <div class="tuiyajin-item highlight">
                                <div class="label">应退积分</div>
                                <div class="value">{{ (tuiyajinData.score) }}</div>
                            </div>
                             <div class="tuiyajin-item highlight">
                                <div class="label">实退积分</div>
                                <div class="value">{{tuiyajinData.liucheng_status == 4 || tuiyajinData.liucheng_status == -1 ? (tuiyajinData.score) : 0  }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="tuiyajin-remark">
                        <div class="tuiyajin-card-title">备注</div>
                        <el-input
                            v-model="tuiyajinData.remark"
                            type="textarea"
                            :rows="3"
                            placeholder="备注"
                        />
                    </div>
                </div>
                <div v-if="showTuiyajinActions" class="tuiyajin-actions">
                    <!--<el-button-->
                        <!--v-if="showOnlineRefundBtn"-->
                        <!--class="tuiyajin-action-btn"-->
                        <!--type="primary"-->
                        <!--:loading="tuiyajinBtnLoading.online"-->
                        <!--:disabled="isAnyTuiyajinSubmitting"-->
                        <!--@click="submitTuiyajinOnline"-->
                    <!--&gt;-->
                        <!--立即线上退押金-->
                    <!--</el-button>-->
                    <el-button
                      v-if="showOnlineRefundBtn"
                      class="tuiyajin-action-btn"
                      type="primary"
                      :loading="tuiyajinBtnLoading.online"
                      :disabled="isAnyTuiyajinSubmitting"
                      @click="submitTuiyajinOffline"
                      >
                      线下退押金
                    </el-button>
                    <el-button
                        v-if="showOfflineRefundBtn"
                        class="tuiyajin-action-btn"
                        type="warning"
                        :loading="tuiyajinBtnLoading.offline"
                        :disabled="isAnyTuiyajinSubmitting"
                        @click="submitTuiyajinOffline"
                    >
                        线下退押金
                    </el-button>
                    <el-button
                        v-if="showBuqiBtn"
                        class="tuiyajin-action-btn"
                        type="success"
                        :loading="tuiyajinBtnLoading.buqi"
                        :disabled="isAnyTuiyajinSubmitting"
                        @click="submitTuiyajinBuqiOffline"
                    >
                        线下补齐款项
                    </el-button>
                </div>
                <div v-else-if="isCompletedStatus" class="tuiyajin-refund-amount">
                    {{tuiyajinData.yajin-tuiyajinData.huan_kouchu_jine>=0?'已退款金额：':'已补齐金额：'}}{{ formatCurrencyDisplay(tuiyajinData.tui_yajin) }}
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import fetch from "@/api/tianzheng/zucheorder";
import { detail, tuiYajin, postxianxiazuche, postRemove, postEdit } from "@/api/tianzheng/zucheorder";
import yuyuecheApi from "@/api/tianzheng/yuyueche";
import Qu from "@/api/tianzheng/Qu";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
import VueUeditorWrap from 'vue-ueditor-wrap';
import ImageUpload from "@/components/Upload/image";
import QucheInfo from "./qucheinfo";
import HuancheInfo from "./huancheinfo";
export default {
    data() {
        return {
            optionList: [],
            fangwuList: [],
            cheList: [],
            thumbList: [],
            queryParam: {
                commId: "",
                name: "",
                ownerName: "",
                ownerPhone: "",
                appointmentRange: [],
                quTimeRange: [],
                huanTimeRange: [],
                liucheng_status: "",
                desc: "",
                page: 1,
                size: 10,
            },
            total: 0,
            listLoading: false,
            tableData: [],
            isEdit: 0, // 0新增 1编辑
            showDrawer: false,
            showXianxiaDrawer: false,
            viewData: {
                id: "",
                commId: "",
                name: "",
                thumb: "",
                desc: "",
                content: "",
                status: 1,
            },
            rules: {
                commId: [
                    {
                        required: true,
                        message: "请选择小区",
                        trigger: "blur",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "请输入车牌号",
                        trigger: "blur",
                    },
                ],
            },
            xianxiaData: {
                commId: '',
                resourceId: '',
                zuche_che_info_id: '',
                name: '',
                phone: '',
                // other_phone: '',
                yajin: 0,
                appointment_date: '',
                appointment_days: 1,
                idcard_thumb: '',
                idcard_thumb_fan: '',
                jiashizheng: '',
                xieyi_pic: '',
                remark: ''
            },
            xianxiaRules: {
                commId: [{ required: true, message: '请选择小区', trigger: 'change' }],
                resourceId: [{ required: true, message: '请选择住房', trigger: 'change' }],
                zuche_che_info_id: [{ required: true, message: '请选择车辆', trigger: 'change' }],
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }],
                yajin: [{ required: true, message: '请输入押金金额', trigger: 'blur' }],
                appointment_date: [{ required: true, message: '请选择预约日期', trigger: 'change' }],
                appointment_days: [{ required: true, message: '请输入预约天数', trigger: 'blur' }],
                idcard_thumb: [{ required: true, message: '请上传驾驶人身份证正面', trigger: 'change' }],
                idcard_thumb_fan: [{ required: true, message: '请上传驾驶人身份证反面', trigger: 'change' }],
                jiashizheng: [{ required: true, message: '请上传驾驶执照正面', trigger: 'change' }],
                xieyi_pic: [{ required: true, message: '请上传协议照片', trigger: 'change' }]
            },
            idcardThumbDefaultList: '',
            idcardThumbFanDefaultList: '',
            jiashizhengDefaultList: '',
            xieyiPicDefaultList: '',
            showUpload: true,
            imageDefaultList: [],
            ueconfig: {
                // UEditor配置
                UEDITOR_HOME_URL: '/static/UEditor/',
                serverUrl: '/api/upload/ueditor',
                // 其他配置项
            },
            // 预约详情抽屉
            showDetailDrawer: false,
            detailData: {},
            detailCancelLoading: false,
            detailEditMode: false,
            detailEditLoading: false,
            detailCheList: [],
            detailEditForm: {
                id: '',
                zuche_che_info_id: '',
                appointment_date: '',
                appointment_days: 1,
                qutime: '',
            },
            detailEditRules: {
                zuche_che_info_id: [{ required: true, message: '请选择车辆', trigger: 'change' }],
                appointment_date: [{ required: true, message: '请选择预约日期', trigger: 'change' }],
                appointment_days: [{ required: true, message: '请输入预约天数', trigger: 'blur' }],
            },
            // 取车抽屉
            showQucheDrawer: false,
            currentOrder: null,
            // 还车抽屉
            showHuancheDrawer: false,
            // 退押金抽屉
            showTuiyajinDrawer: false,
            tuiyajinBtnLoading: {
                online: false,
                offline: false,
                buqi: false,
            },
            tuiyajinData: {
                yajin: 0,
                score: 0,
                pay_price: 0,
                koukuan_yajin: 0,
                appointment_days: 0,
                use_days: 0,
                free_days: 0,
                over_free_days: 0,
                overdue_day_fee: 0,
                weizhang_jine: 0,
                huan_kouchu_jine: 0,
                yingtuijine: 0,
                tui_yajin: '0.00',
                liucheng_status: 0,
                pay_type: '',
                remark: ''
            },
        };
    },
    components: {
        Pagination,
        VueUeditorWrap,
        ImageUpload,
        QucheInfo,
        HuancheInfo,
    },
    created() {},
    mounted() {
        this.getList();
        this.getSelectCity();
    },
    computed: {
        isCompletedStatus() {
            return Number(this.tuiyajinData.liucheng_status) === 4;
        },
        canShowTuiyajinActionByStatus() {
            const status = Number(this.tuiyajinData.liucheng_status);
            return status === 1 || status === 2 || status === 3;
        },
        showTuiyajinActions() {
            return this.canShowTuiyajinActionByStatus && (this.showOnlineRefundBtn || this.showOfflineRefundBtn || this.showBuqiBtn);
        },
        yajinNumber() {
            return this.toNumber(this.tuiyajinData.yajin, 0);
        },
        huanKouchuJineNumber() {
            return this.toNumber(this.tuiyajinData.huan_kouchu_jine, 0);
        },
        yajinDiffNumber() {
            return this.yajinNumber - this.huanKouchuJineNumber;
        },
        isNeedBuqi() {
            return this.yajinDiffNumber < 0;
        },
        isNeedRefund() {
            // 这里如果yajinDiffNumber==0,但是还有积分需要退还，也应该显示退押金按钮，所以不能直接判断yajinDiffNumber是否大于0
            return this.yajinDiffNumber > 0 || this.toNumber(this.tuiyajinData.score, 0) > 0;
        },
        tuiyajinAmountNumber() {
            return this.toNumber(this.tuiyajinData.yingtuijine, 0);
        },
        tuiyajinAmountLabel() {
            return this.tuiyajinAmountNumber < 0 ? '应补交款项' : '应退押金';
        },
        tuiyajinAmountDisplay() {
            const amount = this.tuiyajinAmountNumber < 0 ? Math.abs(this.tuiyajinAmountNumber) : this.tuiyajinAmountNumber;
            return this.formatMoney(amount);
        },
        showOnlineRefundBtn() {
            const payType = Number(this.tuiyajinData.pay_type);
            console.log('payType:', payType);
            const s = this.canShowTuiyajinActionByStatus && this.isNeedRefund && (payType === 1 || payType === 2) && !this.isNeedBuqi;
            return s;
        },
        showOfflineRefundBtn() {
            const payType = Number(this.tuiyajinData.pay_type);
            return this.canShowTuiyajinActionByStatus && this.isNeedRefund && payType === 3;
        },
        showBuqiBtn() {
            return this.canShowTuiyajinActionByStatus && this.isNeedBuqi;
        },
        isAnyTuiyajinSubmitting() {
            return this.tuiyajinBtnLoading.online || this.tuiyajinBtnLoading.offline || this.tuiyajinBtnLoading.buqi;
        },
        showDetailCancelBtn() {
            return this.getLiuchengStatus(this.detailData) === 4;
        },
        canStartDetailEdit() {
            return !!this.pickValue(this.detailData, ['id'], '');
        }
    },
    methods: {
        // 获取下拉列表
        getSelectCity() {
            Qu.select({}).then((res) => {
                if (res.code == 200) {
                    this.optionList = res.result;
                }
            });
        },
        /**
         * @name: 更改状态
         * @param {*} val
         * @return {*}
         * @desc:
         */
        changeStatus(val) {
            let params = {
                id: val.id,
                status: val.status,
            };
            fetch.status(params).then((res) => {
                if (res.code == 200) {
                    this.getList();
                } else {
                    this.getList();
                    this.$message.error(res.message);
                }
            });
        },
        // 更新弹层状态
        onUpdateDrawer(status) {
            if (status == 1) {
                this.showDrawer = false;
                this.getList();
            } else if (status == -1) {
                this.showDrawer = false;
            }
        },
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            this.resetForm();
            if (obj.id) {
                // 编辑
                fetch.detail({ id: obj.id }).then((res) => {
                    if (res.code == 200) {
                        this.viewData = res.result;
                        // 设置图片默认列表
                        if (this.viewData.thumb) {
                            this.imageDefaultList = [{ url: this.viewData.thumb }];
                        } else {
                            this.imageDefaultList = [];
                        }
                    }
                });
            }
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc:
         */
        tijiao(formName) {
            let that = this;
            if(this.thumbList.length<1){
                this.$message.warning("请上传封面图")
                return
            } else {
                this.viewData.thumb = this.thumbList[0];
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.viewData.id) {
                        // 编辑
                        fetch.edit(this.viewData).then((res) => {
                            if (res.code == 200) {
                                that.$message.success(res.message);
                                that.onUpdateDrawer(1);
                            } else {
                                that.$message.error(res.message);
                                that.onUpdateDrawer(-1);
                            }
                        });
                    } else {
                        // 新增
                        fetch.create(this.viewData).then((res) => {
                            if (res.code == 200) {
                                that.$message.success(res.message);
                                that.onUpdateDrawer(1);
                            } else {
                                that.$message.error(res.message);
                                that.onUpdateDrawer(-1);
                            }
                        });
                    }
                } else {
                    this.$message.warning(this.$t("form.verifyMsg"));
                }
            });
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            this.$refs["ruleForm"].resetFields();
            this.viewData = {
                id: "",
                commId: "",
                name: "",
                thumb: "",
                desc: "",
                content: "",
                status: 1,
            };
            this.imageDefaultList = [];
        },
        /**
         * @name: 点击线下租车
         * @return {*}
         * @desc:
         */
        clickXianxiaZuche() {
            this.showXianxiaDrawer = true;
            this.resetXianxiaForm();
            this.getCheList();
            this.$nextTick(() => {
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.clearValidate();
                }
            });
        },
        /**
         * @name: 清空线下租车form
         * @return {*}
         * @desc:
         */
        resetXianxiaForm() {
            // 重置线下租车表单数据
            this.xianxiaData = {
                commId: '',
                resourceId: '',
                zuche_che_info_id: '',
                name: '',
                phone: '',
                // other_phone: '',
                yajin: 0,
                appointment_date: '',
                appointment_days: 1,
                idcard_thumb: '',
                idcard_thumb_fan: '',
                jiashizheng: '',
                xieyi_pic: '',
                remark: ''
            };
            this.idcardThumbDefaultList = '';
            this.idcardThumbFanDefaultList = '';
            this.jiashizhengDefaultList = '';
            this.xieyiPicDefaultList = '';
            this.$nextTick(() => {
                if (this.$refs.idcardThumbUpload) {
                    this.$refs.idcardThumbUpload.clearFileList();
                }
                if (this.$refs.idcardThumbFanUpload) {
                    this.$refs.idcardThumbFanUpload.clearFileList();
                }
                if (this.$refs.jiashizhengUpload) {
                    this.$refs.jiashizhengUpload.clearFileList();
                }
                if (this.$refs.xieyiPicUpload) {
                    this.$refs.xieyiPicUpload.clearFileList();
                }
            });
            this.fangwuList = [];
            this.cheList = [];
        },
        getCheList(commId = '') {
            if(commId == ""){
                this.cheList = [];
                return;
            }
            yuyuecheApi.getCarListBydate({
                commId: commId || '',
                date: this.getDateOnly(this.xianxiaData.appointment_date),
                page: 1,
                size: 9999,
            }).then((res) => {
                this.cheList = (res.result && res.result.list) || [];
            });
        },
        getDateOnly(dateTimeStr) {
            if (!dateTimeStr) return '';
            const str = String(dateTimeStr).trim();
            if (!str) return '';
            return str.split(' ')[0].split('T')[0];
        },
        normalizeDate(value) {
            if (!value) return '';
            const str = String(value).trim().replace('T', ' ');
            if (!str) return '';
            return str.split(' ')[0];
        },
        normalizeDateTime(value) {
            if (!value) return '';
            const str = String(value).trim().replace('T', ' ');
            if (!str) return '';
            if (str.length >= 19) return str.slice(0, 19);
            if (str.length >= 16) return `${str}:00`;
            return str;
        },
        /**
         * @name: 小区改变
         * @param {String} commId
         * @return {*}
         * @desc:
         */
        onCommChange(commId) {
            if (commId) {
                this.xianxiaData.resourceId = '';
                this.xianxiaData.zuche_che_info_id = '';
                this.xianxiaData.name = '';
                this.xianxiaData.phone = '';
                this.getFangwuList(commId);
                this.getCheList(commId);
            } else {
                this.fangwuList = [];
                this.cheList = [];
                this.xianxiaData.resourceId = '';
                this.xianxiaData.zuche_che_info_id = '';
                this.xianxiaData.name = '';
                this.xianxiaData.phone = '';
            }
        },
        /**
         * @name: 获取住户列表
         * @param {String} commId
         * @return {*}
         * @desc:
         */
        getFangwuList(commId) {
            Qu.listTwo({ commId, page: 1, size: 9999 }).then(res => {
                if (res.code == 200) {
                    this.fangwuList = res.result.list2 || [];
                }
            });
        },
        /**
         * @name: 提交线下租车
         * @return {*}
         * @desc:
         */
        submitXianxiaZuche() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    // 假设API
                    fetch.postxianxiazuche(this.xianxiaData).then(res => {
                        if (res.code == 200) {
                            this.$message.success('线下租车成功');
                            this.showXianxiaDrawer = false;
                            this.getList();
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                } else {
                    this.$message.warning('请填写完整信息');
                }
            });
        },
        /**
         * @name: 关闭弹层
         * @return {*}
         * @desc:
         */
        closeDrawerFun() {
            this.showXianxiaDrawer = false;
            this.resetForm();
            this.resetXianxiaForm();
        },
        changeFangwu(resourceId) {
            if (!resourceId || !this.xianxiaData.commId) {
                this.xianxiaData.name = '';
                this.xianxiaData.phone = '';
                return;
            }

            // 优先从已加载的住房列表中尝试回填，提升联动速度
            const selectedRoom = this.fangwuList.find((item) => String(item.resourceId) === String(resourceId));
            if (selectedRoom) {
                this.xianxiaData.name = selectedRoom.name || selectedRoom.userName || selectedRoom.nickname || '';
                this.xianxiaData.phone = selectedRoom.phone || selectedRoom.mobile || '';
            } else {
                this.xianxiaData.name = '';
                this.xianxiaData.phone = '';
            }

            Qu.findUser({
                commId: this.xianxiaData.commId,
                resourceId
            }).then((res) => {
                if (res.code == 200 && res.result) {
                    this.xianxiaData.name = res.result.name || res.result.userName || res.result.nickname || '';
                    this.xianxiaData.phone = res.result.phone || res.result.mobile || '';
                }
            });
        },
        /**
         * @name: 处理图片上传更新
         * @param {Array} imgList
         * @return {*}
         * @desc:
         */
        onUpdateImg(val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList = thumbList;
        },
        extractSingleUploadPath(val) {
            if (!Array.isArray(val) || val.length === 0) return '';
            const first = val[0] || {};
            return first.path || first.url || '';
        },
        onUpdateIdcardThumb(val) {
            this.xianxiaData.idcard_thumb = this.extractSingleUploadPath(val);
        },
        onUpdateIdcardThumbFan(val) {
            this.xianxiaData.idcard_thumb_fan = this.extractSingleUploadPath(val);
        },
        onUpdateJiashizheng(val) {
            this.xianxiaData.jiashizheng = this.extractSingleUploadPath(val);
        },
        onUpdateXieyiPic(val) {
            this.xianxiaData.xieyi_pic = this.extractSingleUploadPath(val);
        },
        clickItem(type, row) {
            let that = this;
            this.showDrawer = true;
            this.isEdit = type;
            // 给组件传值
            let obj = {
                type: type,
                id: row ? row.id : "",
            };
            this.$nextTick(function () {
                that.initFun(obj);
            });
        },
        /* 查询按钮，页码重置，查询数据 */
        searchClick() {
            this.queryParam.page = 1;
            this.getList();
        },
        /* 重置查询条件 */
        resetSearch() {
            this.queryParam = {
                commId: "",
                name: "",
                ownerName: "",
                ownerPhone: "",
                appointmentRange: [],
                quTimeRange: [],
                huanTimeRange: [],
                liucheng_status: "",
                page: 1,
                size: 10,
            };
            this.getList();
        },
        buildListQuery() {
            const params = Object.assign({}, this.queryParam);
            const appointmentRange = Array.isArray(params.appointmentRange) ? params.appointmentRange : [];
            const quTimeRange = Array.isArray(params.quTimeRange) ? params.quTimeRange : [];
            const huanTimeRange = Array.isArray(params.huanTimeRange) ? params.huanTimeRange : [];

            params.owner_name = params.ownerName || '';
            params.user_name = params.ownerName || '';
            params.yezhu_name = params.ownerName || '';
            params.owner_phone = params.ownerPhone || '';
            params.user_phone = params.ownerPhone || '';
            params.yezhu_phone = params.ownerPhone || '';

            params.appointment_start = appointmentRange[0] || '';
            params.appointment_end = appointmentRange[1] || '';
            params.appointment_date_start = appointmentRange[0] || '';
            params.appointment_date_end = appointmentRange[1] || '';

            params.qu_time_start = quTimeRange[0] || '';
            params.qu_time_end = quTimeRange[1] || '';
            params.quTimeStart = quTimeRange[0] || '';
            params.quTimeEnd = quTimeRange[1] || '';

            params.huan_time_start = huanTimeRange[0] || '';
            params.huan_time_end = huanTimeRange[1] || '';
            params.huanTimeStart = huanTimeRange[0] || '';
            params.huanTimeEnd = huanTimeRange[1] || '';

            delete params.ownerName;
            delete params.ownerPhone;
            delete params.appointmentRange;
            delete params.quTimeRange;
            delete params.huanTimeRange;

            return params;
        },
        /* 查询tableData数据 */
        getList() {
            let that = this;
            this.listLoading = true;
            const params = this.buildListQuery();
            fetch.list(params).then((res) => {
                that.listLoading = false;
                that.tableData = res.result.list;
                that.total = res.result.total;
            });
        },
        remove(row) {
            let that = this;
            that
                .$confirm("确定删除该内容吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    // 调用接口
                    fetch.remove({ id: row.id }).then((res) => {
                        if (res.code == 200) {
                            that.$message.success(res.message);
                            that.getList();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                })
                .catch(() => {});
        },
        pickValue(obj, keyList, defaultValue = '--') {
            if (!obj || !Array.isArray(keyList)) return defaultValue;
            for (let i = 0; i < keyList.length; i++) {
                const key = keyList[i];
                const value = key.includes('.') ? this.getNestedValue(obj, key) : obj[key];
                if (value !== undefined && value !== null && value !== '') {
                    return value;
                }
            }
            return defaultValue;
        },
        getNestedValue(obj, path) {
            return path.split('.').reduce((acc, cur) => (acc && acc[cur] !== undefined ? acc[cur] : undefined), obj);
        },
        getOrderSn(row) {
            return this.pickValue(row, ['order_sn', 'orderSn', 'sn']);
        },
        getCommunityName(row) {
            return this.pickValue(row, ['community.commName', 'commName']);
        },
        getResourceName(row) {
            return this.pickValue(row, ['resourceName', 'resource.resourceName', 'resource_name']);
        },
        getPlateNo(row) {
            return this.pickValue(row, ['zuche_che_info.name', 'plateNo', 'carNo', 'car_name', 'name']);
        },
        getUserName(row) {
            return this.pickValue(row, ['wx_user.name', 'userName', 'name']);
        },
        getPhone(row) {
            return this.pickValue(row, ['wx_user.phone', 'phone', 'mobile']);
        },
        // getOtherPhone(row) {
        //     return this.pickValue(row, ['other_phone', 'otherPhone']);
        // },
        toAbsoluteImgUrl(path) {
            if (!path) return '';
            if (/^https?:\/\//.test(path)) return path;
            const baseUrl = (this.$publicData && this.$publicData.imgUrl) || '';
            return `${baseUrl}${path}`;
        },
        parseImageField(value) {
            if (!value) return [];
            if (Array.isArray(value)) {
                return value
                    .map(item => {
                        if (typeof item === 'string') return item;
                        return item.path || item.url || '';
                    })
                    .filter(Boolean);
            }
            if (typeof value === 'string') {
                const trimmed = value.trim();
                if (!trimmed) return [];
                try {
                    const parsed = JSON.parse(trimmed);
                    if (Array.isArray(parsed)) {
                        return parsed
                            .map(item => {
                                if (typeof item === 'string') return item;
                                return item.path || item.url || '';
                            })
                            .filter(Boolean);
                    }
                } catch (error) {
                    // 非 JSON 文本时按单图路径处理
                }
                return [trimmed];
            }
            return [];
        },
        getSingleImage(row, key) {
            if (!row || !key) return '';
            const imageArr = this.parseImageField(row[key]);
            if (!imageArr.length) return '';
            return this.toAbsoluteImgUrl(imageArr[0]);
        },
        getAppointmentDate(row) {
            const value = this.pickValue(row, ['appointment_date', 'appointmentDate', 'yuyueDate']);
            if (!value || value === '--') return '--';
            const str = String(value).trim();
            if (!str) return '--';
            const normalized = str.replace('T', ' ');
            if (normalized.length >= 16) {
                return normalized.slice(0, 16);
            }
            if (normalized.length >= 13) {
                return `${normalized.slice(0, 13)}:00`;
            }
            return normalized.split(' ')[0];
        },
        getAppointmentDays(row) {
            return this.pickValue(row, ['appointment_days', 'appointmentDays', 'yuyueDays']);
        },
        getQuTime(row) {
            return this.pickValue(row, ['qu_time', 'quTime']);
        },
        getQutimeForEdit(row) {
            return this.pickValue(row, ['qutime', 'qu_time', 'quTime'], '');
        },
        getHuanTime(row) {
            return this.pickValue(row, ['huan_time', 'huanTime']);
        },
        getTuiYajinDate(row) {
            return this.pickValue(row, ['tui_yajin_date', 'tuiYajinDate']);
        },
        getYajin(row) {
            return this.pickValue(row, ['yajin']);
        },
        getKoukuanYajin(row) {
            return this.pickValue(row, ['koukuan_yajin', 'koukuanYajin']);
        },
        getTuiYajin(row) {
            return this.pickValue(row, ['tui_yajin', 'tuiYajin']);
        },
        getCreateTime(row) {
            return this.pickValue(row, ['createTime', 'created_at', 'create_time']);
        },
        getStatusText(status) {
            if (status === -1) return '已取消';
            if (status === 1) return '待取车';
            if (status === 2) return '待还车';
            if (status === 3) return '待退押金';
            if (status === 4) return '已完成';
            return '未知';
        },
        getPayTypeText(payType) {
            const type = Number(payType);
            if (type === 1) return '微信支付';
            if (type === 2) return '微信+积分支付';
            if (type === 3) return '线下支付';
            return '--';
        },
        canShowTuiyajinButton(row) {
            return this.getLiuchengStatus(row) === 3;
        },
        isOnlinePayType(payType) {
            const type = Number(payType);
            return type === 1 || type === 2;
        },
        isOfflinePayType(payType) {
            return Number(payType) === 3;
        },
        getLiuchengStatus(row) {
            return Number(this.pickValue(row, ['liucheng_status', 'liuchengStatus', 'status'], 0));
        },
        toNumber(value, defaultValue = 0) {
            const num = Number(value);
            return Number.isFinite(num) ? num : defaultValue;
        },
        formatMoney(value) {
            return this.toNumber(value, 0).toFixed(2);
        },
        formatCurrencyDisplay(value) {
            if (value === undefined || value === null || value === '' || value === '--') return '--';
            const str = String(value).trim();
            if (!str) return '--';
            if (str.startsWith('￥')) return str;
            return `￥${str.replace(/^¥/, '')}`;
        },
        buildTuiyajinData(detailData, rowData = {}) {
            const merged = Object.assign({}, rowData || {}, detailData || {});
            const score = this.toNumber(this.pickValue(merged, ['score']), 0);
            const payPrice = this.toNumber(this.pickValue(merged, ['pay_price', 'payPrice', 'yajin', 'paid_yajin', 'yishouyajin']), 0);
            const yajin = payPrice;
            const appointmentDays = this.toNumber(this.pickValue(merged, ['appointment_days', 'appointmentDays']), 0);
            const useDays = this.toNumber(this.pickValue(merged, ['use_days', 'useDays']), 0);
            const freeDays = this.toNumber(this.pickValue(merged, ['comm_info.mianfeizuche_day', 'commInfo.mianfeizuche_day', 'mianfeizuche_day']), 0);
            const overdueDayFee = this.toNumber(this.pickValue(merged, ['comm_info.yuqi_tian_jine', 'commInfo.yuqi_tian_jine', 'yuqi_tian_jine']), 0);
            const overFreeDays = Math.max(useDays - freeDays, 0);
            const weizhangJine = this.toNumber(this.pickValue(merged, ['weizhang_jine']), 0);
            const defaultKouchu = weizhangJine + overFreeDays * overdueDayFee;
            const koukuanYajin = this.toNumber(
                this.pickValue(merged, ['huan_kouchu_jine', 'koukuan_yajin', 'koukuanYajin']),
                defaultKouchu
            );
            const huanKouchuJine = koukuanYajin;
            const yingtuijine = payPrice - koukuanYajin;

            return {
                yajin: this.formatMoney(yajin),
                score,
                pay_price: this.formatMoney(payPrice),
                koukuan_yajin: this.formatMoney(koukuanYajin),
                appointment_days: appointmentDays,
                use_days: useDays,
                free_days: freeDays,
                over_free_days: overFreeDays,
                overdue_day_fee: this.formatMoney(overdueDayFee),
                weizhang_jine: this.formatMoney(weizhangJine),
                huan_kouchu_jine: this.formatMoney(huanKouchuJine),
                yingtuijine: this.formatMoney(yingtuijine),
                tui_yajin: this.formatMoney(this.pickValue(merged, ['tui_yajin', 'tuiYajin'], 0)),
                liucheng_status: this.getLiuchengStatus(merged),
                pay_type: this.pickValue(merged, ['pay_type', 'payType'], ''),
                xianxia_remark: ''
            };
        },
        getTuiField(keyList) {
            return this.pickValue(this.tuiyajinData, keyList);
        },
        syncDetailEditForm(source = {}) {
            this.detailEditForm = {
                id: this.pickValue(source, ['id'], ''),
                zuche_che_info_id: this.pickValue(source, ['zuche_che_info_id', 'zucheCheInfoId'], ''),
                appointment_date: this.normalizeDate(this.pickValue(source, ['appointment_date', 'appointmentDate'], '')),
                appointment_days: this.toNumber(this.pickValue(source, ['appointment_days', 'appointmentDays'], 1), 1),
                qutime: this.normalizeDateTime(this.getQutimeForEdit(source)),
            };
        },
        resetDetailEditState() {
            this.detailEditMode = false;
            this.detailEditLoading = false;
            this.detailCheList = [];
            this.detailEditForm = {
                id: '',
                zuche_che_info_id: '',
                appointment_date: '',
                appointment_days: 1,
                qutime: '',
            };
            this.$nextTick(() => {
                if (this.$refs.detailEditFormRef) {
                    this.$refs.detailEditFormRef.clearValidate();
                }
            });
        },
        loadDetailCheList() {
            const commId = this.pickValue(this.detailData, ['commId', 'comm_id'], '');
            const date = this.getDateOnly(this.detailEditForm.appointment_date);
            if (!commId || !date) {
                this.detailCheList = [];
                return;
            }
            yuyuecheApi.getCarListBydate({
                commId,
                date,
                page: 1,
                size: 9999,
            }).then((res) => {
                this.detailCheList = (res.result && res.result.list) || [];
                const hasCurrentCar = this.detailCheList.some(item => String(item.id) === String(this.detailEditForm.zuche_che_info_id));
                if (!hasCurrentCar && this.detailEditForm.zuche_che_info_id) {
                    this.detailCheList.unshift({
                        id: this.detailEditForm.zuche_che_info_id,
                        name: this.getPlateNo(this.detailData),
                    });
                }
            });
        },
        onDetailAppointmentDateChange() {
            this.loadDetailCheList();
        },
        startDetailEdit() {
            this.detailEditMode = true;
            this.syncDetailEditForm(this.detailData || {});
            this.loadDetailCheList();
            this.$nextTick(() => {
                if (this.$refs.detailEditFormRef) {
                    this.$refs.detailEditFormRef.clearValidate();
                }
            });
        },
        cancelDetailEdit() {
            this.detailEditMode = false;
            this.syncDetailEditForm(this.detailData || {});
            this.$nextTick(() => {
                if (this.$refs.detailEditFormRef) {
                    this.$refs.detailEditFormRef.clearValidate();
                }
            });
        },
        submitDetailEdit() {
            if (!this.$refs.detailEditFormRef) return;
            this.$refs.detailEditFormRef.validate((valid) => {
                if (!valid) return;
                const payload = {
                    id: this.detailEditForm.id,
                    zuche_che_info_id: this.detailEditForm.zuche_che_info_id,
                    appointment_date: this.detailEditForm.appointment_date,
                    appointment_days: this.detailEditForm.appointment_days,
                    qutime: this.detailEditForm.qutime,
                };
                this.$confirm('确认提交预约信息修改吗？', '二次确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.detailEditLoading = true;
                    postEdit(payload).then((res) => {
                        if (res.code == 200) {
                            this.$message.success(res.message || '修改成功');
                            this.detailEditMode = false;
                            this.getList();
                            this.loadDetailData(payload.id, this.detailData);
                        } else {
                            this.$message.error(res.message);
                        }
                    }).finally(() => {
                        this.detailEditLoading = false;
                    });
                }).catch(() => {});
            });
        },
        openDetailDrawer(row) {
            this.detailData = Object.assign({}, row || {});
            this.resetDetailEditState();
            this.syncDetailEditForm(this.detailData);
            this.showDetailDrawer = true;
            if (row && row.id) {
                this.loadDetailData(row.id, row);
            }
        },
        loadDetailData(id, baseRow = {}) {
            if (!id) return;
            detail({ id }).then((res) => {
                if (res.code == 200) {
                    this.detailData = Object.assign({}, baseRow || {}, res.result || {});
                    if (this.detailEditMode) {
                        this.syncDetailEditForm(this.detailData);
                        this.loadDetailCheList();
                    }
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        cancelDetailOrder() {
            const id = this.pickValue(this.detailData, ['id'], '');
            if (!id || id === '--') {
                this.$message.warning('缺少订单ID，无法取消');
                return;
            }
            this.detailCancelLoading = true;
            postRemove({ id }).then((res) => {
                if (res.code == 200) {
                    this.$message.success(res.message || '取消订单成功');
                    this.getList();
                    this.loadDetailData(id, this.detailData);
                } else {
                    this.$message.error(res.message);
                }
            }).finally(() => {
                this.detailCancelLoading = false;
            });
        },
        closeDetailDrawer() {
            this.showDetailDrawer = false;
            this.detailData = {};
            this.detailCancelLoading = false;
            this.resetDetailEditState();
        },
        // 取车
        quche(row) {
            this.currentOrder = row;
            this.showQucheDrawer = true;
        },
        // 还车
        huanche(row) {
            this.currentOrder = row;
            this.showHuancheDrawer = true;
        },
        onQucheDrawerClosed() {
            this.currentOrder = null;
        },
        onHuancheDrawerClosed() {
            this.currentOrder = null;
        },
        // 押金信息
        tuiyajin(row) {
            this.currentOrder = row;
            this.showTuiyajinDrawer = true;
            detail({ id: row.id }).then(res => {
                if (res.code == 200) {
                    this.tuiyajinData = this.buildTuiyajinData(res.result, row);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        closeTuiyajinDrawer() {
            this.showTuiyajinDrawer = false;
            this.currentOrder = null;
            this.tuiyajinData = {
                yajin: 0,
                score: 0,
                pay_price: 0,
                koukuan_yajin: 0,
                appointment_days: 0,
                use_days: 0,
                free_days: 0,
                over_free_days: 0,
                overdue_day_fee: 0,
                weizhang_jine: 0,
                huan_kouchu_jine: 0,
                yingtuijine: 0,
                tui_yajin: '0.00',
                liucheng_status: 0,
                pay_type: '',
                xianxia_remark: ''
            };
        },
        // 立即线上退押金
        submitTuiyajinOnline() {
            this.$confirm('确认退押金吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.tuiyajinBtnLoading.online = true;
                tuiYajin({
                    id: this.currentOrder.id,
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success('提交线上退押金信息成功，请留意微信信息！');
                        this.closeTuiyajinDrawer();
                        this.getList();
                    } else {
                        this.$message.error(res.message);
                    }
                }).finally(() => {
                    this.tuiyajinBtnLoading.online = false;
                });
            }).catch(() => {});
        },
        // 线下退押金（含补齐款项，具体由后端根据金额处理）
        submitTuiyajinOfflineCommon(loadingKey = 'offline') {
            this.$confirm('确认线下退押金吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.tuiyajinBtnLoading[loadingKey] = true;
                tuiYajin({
                    id: this.currentOrder.id,
                    remark: this.tuiyajinData.remark
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(this.tuiyajinAmountNumber < 0 ? '线下补齐款项成功' : '线下退押金成功');
                        this.closeTuiyajinDrawer();
                        this.getList();
                    } else {
                        this.$message.error(res.message);
                    }
                }).finally(() => {
                    this.tuiyajinBtnLoading[loadingKey] = false;
                });
            }).catch(() => {});
        },
        // 线下退押金
        submitTuiyajinOffline() {
            this.submitTuiyajinOfflineCommon('offline');
        },
        // 线下补齐款项
        submitTuiyajinBuqiOffline() {
            this.submitTuiyajinOfflineCommon('buqi');
        },
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    min-height: calc(100vh - 98px);
}

.search-div {
    margin-bottom: 20px;
    padding: 15px;
    background: #fff;
    border-radius: 4px;
}

.search-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.search-buttons .el-button {
    flex: none;
}

/* Table样式优化 */
.custom-table {
    border-radius: 4px;
    overflow: hidden;
}

.custom-table ::v-deep .el-table__header th {
    background-color: #f5f7fa !important;
    color: #606266 !important;
    font-weight: bold !important;
    border-bottom: 1px solid #ebeef5;
}

.custom-table ::v-deep .el-table__row {
    border-bottom: 1px solid #ebeef5;
}

.custom-table ::v-deep .el-table__row:last-child {
    border-bottom: none;
}

/* 响应式布局 */
@media (max-width: 768px) {
    .search-div {
        padding: 10px;
    }

    .search-buttons {
        justify-content: flex-start;
        margin-top: 10px;
    }

    .search-buttons .el-button {
        margin-bottom: 5px;
    }

    .custom-table {
        font-size: 12px;
    }

    .custom-table ::v-deep .el-table__header th,
    .custom-table ::v-deep .el-table__row td {
        padding: 8px 4px;
    }
}

.btns-wrap {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.btns-wrap .el-button {
    margin-left: 0 !important;
}

.tuiyajin-panels {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.tuiyajin-card,
.tuiyajin-remark {
    background: #f8fafc;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px;
}

.tuiyajin-card-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 10px;
}

.tuiyajin-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
}

.tuiyajin-item {
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f0f2f5;
    padding: 10px;
}

.tuiyajin-item .label {
    font-size: 12px;
    color: #909399;
    line-height: 18px;
}

.tuiyajin-item .value {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 20px;
}

.tuiyajin-item.highlight .value {
    color: #1067e0;
}

.tuiyajin-actions {
    margin-top: 16px;
    display: flex;
    gap: 12px;
}

.tuiyajin-action-btn {
    flex: 1;
    height: 36px;
    font-size: 14px;
}

.tuiyajin-actions .el-button + .el-button {
    margin-left: 0;
}

.detail-actions {
    margin-top: 8px;
    display: flex;
    justify-content: flex-end;
}

.tuiyajin-refund-amount {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    text-align: right;
}

@media (max-width: 768px) {
    .tuiyajin-grid {
        grid-template-columns: 1fr;
    }
}

.detail-img-wrap {
    line-height: 1;
}

.detail-img {
    width: 120px;
    height: 80px;
    object-fit: cover;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    display: inline-block;
}

</style>
